import { useEffect, useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useBackend } from "../backend/BackendProvider";
import { ErrorState, LoadingState } from "../components/AsyncState";
import { TaskDetail } from "../components/TaskDetail";

type SourceState = { from?: string; fromLabel?: string; taskId?: string };

export function TaskDetailsPage() {
  const { taskId = "" } = useParams();
  const backend = useBackend(); const navigate = useNavigate(); const location = useLocation();
  const source = location.state as SourceState | null;
  const task = useQuery({ queryKey: ["task", taskId], queryFn: () => backend.tasks.get(taskId), enabled: Boolean(taskId) });
  const project = useQuery({ queryKey: ["project", task.data?.projectId], queryFn: () => backend.projects.get(task.data!.projectId!), enabled: Boolean(task.data?.projectId) });
  const area = useQuery({ queryKey: ["area", task.data?.areaId], queryFn: () => backend.areas.get(task.data!.areaId!), enabled: Boolean(task.data?.areaId) });
  const fallback = task.data?.projectId ? `/projects/${task.data.projectId}` : task.data?.areaId ? `/areas/${task.data.areaId}` : "/today";
  const fallbackLabel = task.data?.projectId ? `Back to ${project.data?.name ?? "Project"}` : task.data?.areaId ? `Back to ${area.data?.name ?? "Area"}` : "Back to Today";
  const backLabel = source?.fromLabel ?? fallbackLabel;
  const goBack = () => {
    if (source?.from) navigate(-1);
    else navigate(fallback, { replace: true });
  };
  const scrollRef = useRef(0);
  useEffect(() => {
    const onScroll = () => { scrollRef.current = window.scrollY; };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => { window.removeEventListener("scroll", onScroll); sessionStorage.setItem(`task-scroll:${taskId}`, String(scrollRef.current)); };
  }, [taskId]);
  useEffect(() => {
    if (!task.data) return;
    const saved = Number(sessionStorage.getItem(`task-scroll:${taskId}`));
    if (Number.isFinite(saved) && saved > 0) requestAnimationFrame(() => window.scrollTo(0, saved));
  }, [task.data, taskId]);
  if (task.isLoading) return <div className="page"><LoadingState /></div>;
  if (task.isError && !task.data) return <div className="page"><ErrorState error={task.error} retry={() => void task.refetch()} /><p><button className="button" onClick={goBack}>{fallbackLabel}</button></p></div>;
  return <div className="page task-details-page"><TaskDetail taskId={taskId} variant="page" backLabel={backLabel} onClose={goBack} focusOnOpen /></div>;
}
